import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './components/layout/layout.component';
import { IonicModule } from '@ionic/angular';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SidemenuComponent } from './components/sidemenu/sidemenu.component';
import { AssistantModule } from '../assistant/assistant.module';



@NgModule({
  declarations: [LayoutComponent, NavbarComponent, SidemenuComponent],
  imports: [
    CommonModule,
    IonicModule,
    AppRoutingModule,
    AssistantModule
  ],
  exports: [
    LayoutComponent
  ]
})
export class LayoutModule { }
